(function () {
    angular.module('charts')
      .directive('dblStudentOverview', function () {
          return {
              restrict: 'E',
              scope: {
                  dblStudent: '=',
                  dblTimeframeObservable: '=',
                  dblAstName: '=',
                  dblOptions: '=',
                  dblOnDoneRendering: '&'
              },
              templateUrl: '/resources/right-pane/components/student-overview/dbl-student-overview.directive.html',
              controller: [
                  '$log',
                  '$modal',
                  '$q',
                  '$scope',
                  '$timeout',
                  'activityApi',
                  'assignedFocusApi',
                  'dblProficiencyApi',
                  'reportErrors',
                  'studentApi',
                  'timeframe',
                  'dblUsageFactory',
                  'authentication',
                  'configuration',
                  'edxStateParamsService',
                  '$state',
                DblStudentOverviewController] // end controller
          };
      });

    function DblStudentOverviewController(
      $log,
      $modal,
      $q,
      $scope,
      $timeout,
      activityApi,
      assignedFocusApi,
      dblProficiencyApi,
      dblReportErrors,
      dblStudentApi,
      timeframe,
      dblUsageFactory,
      authentication,
      configuration,
      edxStateParamsService,
      $state
) {
        $scope.useBts2020View = authentication.useBts2020Nav();
        $scope.isLite = configuration.isFeatureEnabled('dbl_lite');

        // For now assume options are set once when parent is constructed and don't change.
        if ($scope.dblOptions) {
            $scope.canAssignLessons = $scope.dblOptions.canAssignLessons;
            $scope.efpEnabled = $scope.dblOptions.efpEnabled;
            $scope.hideStudentPlacement = $scope.dblOptions.hideStudentPlacement;
            $scope.loadStandards = $scope.dblOptions.loadStandards;
            $scope.viewMode = $scope.dblOptions.viewMode;
        }

        var studentDeferred = $q.defer();

        function updateStudentData() {
            var districtId = $scope.item.districtId;
            var studentId = $scope.item.id || $state.params.studentId;

            updateEngagementActivities();

            $scope.showAlerts = $scope.item && $scope.item.status_reason_codes &&
              $scope.item.status_reason_codes.length > 0 && timeframe.isRecent();
            if (authentication.getCustomer().hasTag('INSIGHT_EFP') && configuration.isFeatureEnabled('alerts_efp_enabled')) {
                $scope.showAlerts = false;
            }

            $scope.gradeLevel = undefined;
            $scope.reportError = null;

            $scope.usageData = undefined;
            dblStudentApi.getStudentsReportingForStudent(districtId, studentId).then(function (studentData) {
                $scope.usageData = dblUsageFactory.extractUsageData(studentData);
                $scope.displayAverages = timeframe.getDaysInSelectedPeriod() > 7;

                $scope.studentData = angular.copy(studentData);
                $scope.gradeLevel = studentData.grade_level;
                $scope.growthStandardsNames = {
                    completed: studentData.standards_growth_names,
                    inProgress: studentData.standards_partial_growth_names
                };

                // Sort the grades array by ordinal because we can't assume it will come back pre-sorted
                $scope.studentData.grades = _.sortBy($scope.studentData.grades, function (o) {
                    return o.ordinal;
                });
            }, function (error) {
                $scope.studentData = undefined;
                $scope.growthStandardsNames = undefined;
                $scope.reportError = dblReportErrors.getErrorMessage(error);
                $log.error('Unable to load student data.');
            });

            var days = timeframe.parseNumber('day');
            days = isFinite(days) ? days : undefined;
            var sy = timeframe.parseNumber('year');
            sy = isFinite(sy) ? sy : undefined;
            var fd = timeframe.getFromDate();
            var td = timeframe.getToDate();
            var includesThePresent = timeframe.includesThePresent();
            updateProficiencyTable(districtId, studentId, $scope.dblAstName, days, sy, fd, td, includesThePresent, $scope.loadStandards);
        }

        function updateProficiencyTable(districtId, studentId, ast, days, sy, fd, td, includesThePresent, loadStandards) {
            $scope.proficiencyOverviewError = undefined;
            $scope.proficiencyTable = undefined;
            $scope.proficiencyDateMessage = undefined;

            dblProficiencyApi.getStudentDomainTable(districtId, studentId, ast,
              days, sy, fd, td, includesThePresent, loadStandards).then(function (proficiencyTable) {

                $scope.proficiencyTable = proficiencyTable;
                $scope.proficiencyDateMessage = timeframe.getPrettyProficiency();

                // timeout allows another Angular cycle to render the table before notifying of
                // completion
                $timeout(function () {
                    if ($scope.dblOnDoneRendering) {
                        $scope.dblOnDoneRendering({
                            studentId: $scope.item.id
                        });
                    }
                });
            }, function (error) {
                var msg = dblReportErrors.getErrorMessage(error);
                if (!msg) {
                    msg = 'Unable to load proficiency data.';
                }

                $scope.proficiencyOverviewError = msg;

                // timeout allows another Angular cycle to render the table before notifying of
                // completion
                $timeout(function () {
                    if ($scope.dblOnDoneRendering) {
                        $scope.dblOnDoneRendering({
                            studentId: $scope.item.id,
                            errorMsg: msg
                        });
                    }
                });
            });
        }

        function updateEngagementActivities() {
          var districtId = $scope.item.districtId;
          var studentId = $scope.item.id || $state.params.studentId;
          $scope.engagementActivitiesError = null;
          activityApi.getStudentEngagementActivity(districtId, studentId).then(function (data) {
            $scope.engagementEvents = data.events;
          }, function (error) {
            var msg = dblReportErrors.getErrorMessage(error);
            if (!msg) {
              msg = 'Unable to load student achievements.';
            }

            $scope.engagementActivitiesError = msg;
          });
        }

        function isAssignmentActive(assignment) {
            return assignment.status === 'ACTIVE' && !_.startsWith(assignment.student_status, "COMPLETE") &&
              !_.startsWith(assignment.student_status, "REMOVED");
        }

        function updateAssignments() {
            assignedFocusApi.getStudentAssignedLessonsHistory($scope.item.id || $state.params.studentId, function (history) {
                history = history.assignments;

                $scope.assignments = _.filter(history, function (assignment) {
                    return isAssignmentActive(assignment);
                });

                return assignedFocusApi.appendFocusData($scope.assignments);
            });
        }

        function viewProgressClicked(e, assignment) {
            $modal.open({
                templateUrl: 'resources/core/partials/student-progress-modal.html',
                windowClass: 'fill-view-modal student-progress-modal',
                controller: 'StudentProgressModalController',
                backdrop: 'static',
                scope: $scope,
                resolve: {
                    progressData: function () {
                        var data = assignedFocusApi.createProgressDataFromAssignment(assignment);
                        data.grade = $scope.item.grade;
                        data.districtId = $scope.item.districtId;

                        return data;
                    }
                }
            });
        }

        function updateAlerts() {
          var params = _.pick($state.params, ['districtId']);
          params.student_id = $scope.item.id;
          params = _.extend(params, edxStateParamsService.getTimeframeParamsForEarlyHighlights());

          dblStudentApi.getStudentHighlights(params).then(function (studentData) {
            $scope.status_reason_codes = studentData.status_reason_codes;
          });
        }

        function initializeData(item) {
            studentDeferred.resolve(item);
            $scope.item = item;

            updateAssignments();
            updateAlerts();
        }

        $scope.isBusy = function(){
          return $scope.assignments && $scope.assignments.length === 2;
        };

        $scope.$watch('dblTimeframeObservable', function (newVal) {
            if (newVal) {
                studentDeferred.promise.then(updateStudentData);
            }
        });

        $scope.$watch('dblStudent', function (newVal) {
            if (newVal) {
                initializeData(newVal);
            }
        });

        $scope.$on('viewProgressClick', viewProgressClicked);

    }
})();
